// @ts-check

import 'vuetify/styles'

import { i18n } from '@/i18n'
import * as feedback from '@/vuetify/feedback'
import * as fields from '@/vuetify/fields'
import { icons } from '@/vuetify/icons'
import * as buttons from '@/vuetify/buttons'
import { useI18n } from 'vue-i18n'
import { createVuetify } from 'vuetify'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { colors } from '../../themes'

/** @type {import('vuetify').VuetifyOptions} */
export const vuetifyOptions = {
  theme: {
    themes: {
      dark: {
        dark: true,
        colors: {
          primary: colors.primary.DEFAULT,
          secondary: colors.secondary.DEFAULT,
          info: colors.info.DEFAULT,
          error: colors.danger.DEFAULT,
          warning: colors.warning.DEFAULT,
          success: colors.success.DEFAULT
        },
        variables: {
          'disabled-opacity': 0.6
        }
      },
      light: {
        dark: false,
        colors: {
          primary: colors.primary.DEFAULT,
          secondary: colors.secondary.DEFAULT,
          info: colors.info.DEFAULT,
          error: colors.danger.DEFAULT,
          warning: colors.warning.DEFAULT,
          success: colors.success.DEFAULT
        },
        variables: {
          'disabled-opacity': 0.6
        }
      }
    }
  },
  components: {
    VDateInput
  },
  aliases: {
    ...buttons.aliases,
    ...feedback.aliases,
    ...fields.aliases
  },
  defaults: {
    ...buttons.defaults,
    ...feedback.defaults,
    ...fields.defaults,
    VTooltip: {
      openOnClick: true,
      openOnHover: true,
      scrollStrategy: 'close',
      maxWidth: 500
    },
    VRadioGroup: {
      ripple: typeof jest === 'undefined'
    },
    VLabel: {
      class: ['whitespace-normal']
    }
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  icons
}

export const vuetify = createVuetify(vuetifyOptions)

export default vuetify
